import axios from "axios";
import { getAuthHeader } from "./authHeader";
import { AssetUsageResponse } from "../types/assetUsage";

// How many scheduled posts use the selected tiles, for the delete dialog. Any
// failure reads as zero, so this lookup never blocks a delete.
export const fetchPendingPostCount = async (ids: string[]): Promise<number> => {
    if (!ids || ids.length === 0) {
        return 0;
    }
    try {
        const headers = await getAuthHeader();
        const backendUrl = process.env.REACT_APP_BACKEND_URL;
        const { data } = await axios.get<AssetUsageResponse>(
            `${backendUrl}/assets/usage?ids=${encodeURIComponent(ids.join(","))}`,
            { headers },
        );
        return typeof data?.pendingPosts === "number" ? data.pendingPosts : 0;
    } catch (error) {
        console.error("Could not count scheduled posts using this media:", error);
        return 0;
    }
};

export const pendingPostsLine = (count: number): string | null => {
    if (!count || count <= 0) {
        return null;
    }
    if (count === 1) {
        return "1 scheduled post uses this media. It will still go out.";
    }
    return `${count} scheduled posts use this media. They will still go out.`;
};
